/**
 * PressBadge — "AS SEEN ON" trust badge with verifiable proof.
 *
 * WhyIQ audit Phase 2 fix #6: unverifiable media logos erode trust.
 * Clicking the badge routes to /press where every CBS/NBC/FOX/ABC
 * article is listed by syndication date — proof, not vibes.
 *
 * Rendered identically on:
 *   - Home.js        (post-launch homepage)
 *   - ComingSoon.js  (pre-launch landing page)
 *
 * Parent supplies the navigate handler so this component stays
 * router-agnostic and easy to use in any page that has a routing
 * context already wired up.
 */
import React from 'react';

/**
 * @param {object}   props
 * @param {function} props.onClick     Handler that should route to /press and scroll-to-top.
 * @param {string}   [props.className] Wrapper class override (defaults to centered flex with mb-6).
 * @param {string}   [props.testId]    Override the wrapping div's data-testid (parents may want a page-scoped id).
 */
export default function PressBadge({
  onClick,
  className = 'flex justify-center mb-6',
  testId = 'homepage-as-seen-on-badge',
}) {
  return (
    <div className={className} data-testid={testId}>
      <button
        type="button"
        onClick={onClick}
        className="group inline-flex flex-col items-center gap-1 cursor-pointer"
        aria-label="View press coverage on CBS, NBC, FOX, and ABC"
        data-testid="homepage-as-seen-on-link"
      >
        <img
          src="/as-seen-on-badge.png"
          alt="As Seen On - CBS, NBC, ABC, FOX"
          className="h-12 sm:h-14 md:h-16 w-auto object-contain opacity-60 group-hover:opacity-100 transition-opacity"
        />
        <span className="text-[10px] uppercase tracking-[0.18em] text-neutral-500 group-hover:text-[#00F0FF] transition-colors">
          See coverage →
        </span>
      </button>
    </div>
  );
}
